import { LOCAL_STORAGE_KEYS } from './local-storage.constant';
import { set, get } from 'idb-keyval';

export class LocalStorageManager {

    /**
     * 设置本地存储
     * @param path 本地存储的key
     */
    public static setLocalStorage(action: { path: LOCAL_STORAGE_KEYS, value: unknown }) {
        try {
            localStorage.setItem(action.path, JSON.stringify(action.value));
        } catch (error) { }
    }

    /**
     * 获取本地存储
     * @param path 本地存储的key
     */
    public static getLocalStorage(path: LOCAL_STORAGE_KEYS) {
        try {
            let value: any = localStorage.getItem(path);
            if (value) {
                value = JSON.parse(value);
            }
            return value;
        } catch (error) { }
    }
}


export class IndexedDBManager {
    public static async set(action: { path: LOCAL_STORAGE_KEYS, value: unknown }) {
        // 清除旧的key
        removeInvalidKey(action.path);
        await set(action.path, action.value);
    }
    public static async get(path: LOCAL_STORAGE_KEYS) {
        const value: any = await get(path);
        return value;
    }
}

// 移除无效key （后期可删除代码）
function removeInvalidKey(key) {
    localStorage.removeItem(key);
}